import { useNavigate } from "react-router-dom";

import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

import PaymentsIcon from "@mui/icons-material/Payments";

import Box from "@mui/material/Box";

import Grid from "@mui/material/Grid";

import Paper from "@mui/material/Paper";

import Stack from "@mui/material/Stack";

import Typography from "@mui/material/Typography";

import { rootProtectedPath, services } from "data/authData";

import { lfsSalePaymentDashboardServices } from "./data";

import { cardSx, explorePageSx } from "./sharedStyles";



const LfsSalePaymentWorkingExplore = () => {

	const navigate = useNavigate();



	const handleServiceClick = (path) => {

		navigate(`/${rootProtectedPath}/${services.lfs_sale_payment_working.path}/${path}`);

	};



	const serviceItems = Object.values(lfsSalePaymentDashboardServices).flatMap((service) =>

		Object.values(service.types || {}).filter((item) => item.display)

	);



	return (

		<Box sx={explorePageSx}>

			<Paper

				elevation={0}

				sx={{

					...cardSx,

					mb: 4,

					background: "linear-gradient(135deg, #212121 0%, #424242 100%)",

					color: "#fff",

					border: "none",

				}}

			>

				<Stack

					direction={{ xs: "column", sm: "row" }}

					spacing={2}

					alignItems={{ xs: "flex-start", sm: "center" }}

					sx={{ p: { xs: 3, sm: 4 } }}

				>

					<Box

						sx={{

							width: 56,

							height: 56,

							borderRadius: 2.5,

							display: "grid",

							placeItems: "center",

							bgcolor: "rgba(255, 255, 255, 0.12)",

						}}

					>

						<PaymentsIcon sx={{ fontSize: 30 }} />

					</Box>

					<Box>

						<Typography variant="overline" sx={{ opacity: 0.85, letterSpacing: 1.2 }}>

							Sale Operations

						</Typography>

						<Typography variant="h4" fontWeight={700} sx={{ mt: 0.5 }}>

							LFS Sale Payment Working

						</Typography>

						<Typography variant="body1" sx={{ mt: 1, opacity: 0.9, maxWidth: 560 }}>

							Upload sale data, apply offers, download payment working files, and

							verify offer eligibility — all in one place.

						</Typography>

					</Box>

				</Stack>

			</Paper>



			<Typography variant="subtitle2" color="text.secondary" fontWeight={600} mb={2}>

				Choose a workflow

			</Typography>



			<Grid container spacing={2.5}>

				{serviceItems.map((item) => (

					<Grid item xs={12} sm={6} md={4} key={item.key}>

						<Paper

							elevation={0}

							onClick={() => handleServiceClick(item.key)}

							sx={{

								...cardSx,

								p: 2.5,

								height: "100%",

								cursor: "pointer",

								display: "flex",

								flexDirection: "column",

								transition: "all 0.2s ease",

								"&:hover": {

									borderColor: "#212121",

									boxShadow: "0 12px 40px rgba(15, 23, 42, 0.1)",

									transform: "translateY(-2px)",

								},

							}}

						>

							<Box

								sx={{

									width: 44,

									height: 44,

									borderRadius: 2,

									display: "grid",

									placeItems: "center",

									bgcolor: "rgba(33, 33, 33, 0.06)",

									color: "#212121",

									mb: 2,

								}}

							>

								{item.icon}

							</Box>

							<Typography variant="h6" fontWeight={700} gutterBottom>

								{item.name}

							</Typography>

							<Typography

								variant="body2"

								color="text.secondary"

								sx={{ flex: 1, mb: 2 }}

							>

								{item.description}

							</Typography>

							<Stack direction="row" alignItems="center" spacing={0.5} color="#212121">

								<Typography variant="body2" fontWeight={600}>

									Open

								</Typography>

								<ArrowForwardRoundedIcon sx={{ fontSize: 18 }} />

							</Stack>

						</Paper>

					</Grid>

				))}

			</Grid>

		</Box>

	);

};



export default LfsSalePaymentWorkingExplore;

